import { Image as GrommetImage, ImageProps } from 'grommet';
import useResponsive from 'hooks/useResponsive';
import React from 'react';
import { imageUrl } from 'services/image';
import { splitByLastDot } from 'utils/stringUtils';

export enum ImageSize {
  xxsmall = 100,
  xsmall = 300,
  small = 500,
  medium = 750,
  large = 1000,
  xlarge = 1500,
  xxlarge = 2500,
}

const smartSrc = (src: string | undefined) =>
  (!src &&
    'https://images.unsplash.com/photo-1496094964281-6b2e28422c5c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80') ||
  (src?.includes('http') && src) ||
  `${imageUrl()}${src}`;

const maybeEnrichSrc = (src: string | undefined, size: string) => {
  if (!src) return src;
  const [key, type] = splitByLastDot(src);
  return `${key}.${type}`;
};

const Image = ({ src, ...props }: ImageProps & any) => {
  const { size } = useResponsive();
  const enrichedSrc = maybeEnrichSrc(src, size);
  return <GrommetImage fit="cover" {...props} src={smartSrc(enrichedSrc)} />;
};

export default Image;
